import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "./Auth/AuthProvider"
import App from "./App"
import Footer from "./Components/Footer/Footer"
import "./firebase"
import "./index.css"

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
)

createRoot(document.getElementById("footer")).render(
  <Footer />
)
